import config from '../config';

const firebaseConfig = {
  messagingSenderId: config.FIREBASE_MESSAGING_SEND_ID,
  apiKey: 'AIzaSyA4I1LJLuqDH-JCCPM49q8ya45JDgXOIho',
  authDomain: 'feedback-f859f.firebaseapp.com',
  databaseURL: 'https://feedback-f859f.firebaseio.com',
  projectId: 'feedback-f859f',
  storageBucket: 'feedback-f859f.firebasestorage.app',
  appId: '1:402684375599:web:c1908520baeffee3368cda',
  measurementId: 'G-GKLYSM8ZLX',
};

export default firebaseConfig;
